import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { themes, SimpleForm, SimpleFormGroup, Dialog, SimpleSelect } from 'libs/ui';
import { getTariffList } from 'services/tariffs-service';

export const TariffSetForm = (props) => {
  const { working } = props;
  const { t } = useTranslation();
  const [tariff, setTariffState] = useState('');
  const [tariffs, setTariffs] = useState([]);

  // get tariffs
  useEffect(() => {
    // parking_id: props.parkingId
    getTariffList({ status: 'active' }, []).then((data) => {
      setTariffs(data.items);
    });
  }, []);

  /**
   * make action
   * @param {*} event
   */
  const action = () => {
    props.action({ tariff_id: tariff });
  };

  /**
   * select change
   * @param {*} event
   */
  const handleTariffChange = (event) => {
    setTariffState(event.target.value);
  };

  /**
   * get tariffs elements
   * @returns
   */
  const getTariffsEl = () => {
    return tariffs.map((tariff) => (
      <option key={tariff.id} value={tariff.id}>
        {tariff.name}
      </option>
    ));
  };

  if (!tariffs.length) {
    return null;
  }

  const tariffsEl = getTariffsEl();
  const valid = !!tariff;

  // TODO: delete langs
  // {t('payment_method.Выберите значение')}
  return (
    <Dialog
      id="dialog-tariff-set-form"
      title={t('form.Смена тарифа')}
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Заменить'), onClick: action, theme: themes.blue, disabled: !valid || working, working },
      ]}
    >
      <SimpleForm>
        <SimpleFormGroup>
          <label htmlFor="set-form-tariff">{t('form.Тариф')}</label>
          <SimpleSelect id="set-form-tariff" onChange={handleTariffChange} value={tariff}>
            <option value="">{t('form.Не задано')}</option>
            {tariffsEl}
          </SimpleSelect>
        </SimpleFormGroup>
      </SimpleForm>
    </Dialog>
  );
};

TariffSetForm.propTypes = {
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
};
